import React from 'react';
import BannerSection from './BannerSection/BannerSection';

const Home = () => {
    return (
        <div>
            <BannerSection></BannerSection>
        </div>
    );
};

export default Home;